export default __webpack_public_path__ + "static/media/kid-profile.7f7d1703.svg";